import { useState, useCallback } from 'react';

export function useLocalStorage<T>(key: string, initialValue: T) {
  // Get from local storage then parse stored json or return initialValue
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {

      return initialValue;
    }
  });

  // Stable setter: functional updater okur, böylece deps'e storedValue koymak gerekmez.
  // Aksi halde her render'da yeni referans dönerek tüketen efektlerde sonsuz döngüye yol açar.
  const setValue = useCallback((value: T | ((val: T) => T)) => {
    setStoredValue((prev) => {
      const valueToStore = value instanceof Function ? value(prev) : value;
      try {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {

      }
      return valueToStore;
    });
  }, [key]);

  return [storedValue, setValue] as const;
}
